/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetVCCOrderDetails,
    GetSupplierDetailsForOrder,
    GetSupplierCropVarityQuntityDetails,
    ApproveOrder,
    AddSuppliers,
    RemoveSuppliers,
    EditSuppliers,
    ReturnOrder,
    ApproveReadyToWeighment,
    GetVCCOrderBreakdownDetailsByPerformOrderID,
    GetMergeCropDetailsByPerformOrderID
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetVCCOrderDetails(operationEntityID, date) {
    const response = await CommonGet('/api/Supplier/GetVCCOrderDetails', 'operationEntityID=' + parseInt(operationEntityID) + '&date=' + date);
    return response.data;
}

async function GetSupplierDetailsForOrder(operationEntityID, cropID, date) {
    const response = await CommonGet('/api/Supplier/GetSupplierDetailsForOrder', 'operationEntityID=' + parseInt(operationEntityID) + '&cropID=' + parseInt(cropID) + '&date=' + date);
    return response.data;
}

async function GetMergeCropDetailsByPerformOrderID(performOrderID) {
    const response = await CommonGet('/api/Supplier/GetMergeCropDetailsByPerformOrderID', 'performOrderID=' + parseInt(performOrderID));
    return response.data;
}

async function GetSupplierCropVarityQuntityDetails(farmerID, cropID, date) {
    const response = await CommonGet('/api/Supplier/GetSupplierCropVarityQuntityDetails', 'farmerID=' + parseInt(farmerID) + '&cropID=' + parseInt(cropID) + '&date=' + date);
    return response.data;
}

async function ApproveOrder(data) {
    var values = {
        performOrderID: parseInt(data.performOrderID),
        quantity: parseFloat(data.quantity),
        productCode: data.productCode,
        orderDate: data.orderDate,
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/Supplier/ApproveOrder', null, values);
    return response;
}

async function AddSuppliers(supplierOrderDeails, supplierData, breakdownDetails) {

    var values = {
        performOrderID: parseInt(supplierOrderDeails.performOrderID),
        cropForecastDetailID: parseInt(supplierData.cropForecastDetailID),
        operationEntityID: parseInt(supplierOrderDeails.operationEntityID),
        farmerID: parseInt(supplierData.farmerID),
        cropID: parseInt(supplierData.cropID),
        cropVarietyID: parseInt(supplierData.cropVarityID),
        dueDate: supplierOrderDeails.orderDate,
        productCode: supplierOrderDeails.productCode,
        acceptedQuantity: parseFloat(supplierData.quantity),
        availbaleQuantity: parseFloat(supplierData.availbaleQty),
        remainingQuantity: parseFloat(supplierData.reaminCount),
        breakdownDetails: breakdownDetails,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/Supplier/AddSupplier', null, values);
    return response;
}

async function RemoveSuppliers(supplierData, supplierOrderDeails, breakdownDetails) {
    var values = {
        performOrderFarmerMappingID: parseInt(supplierData.performOrderFarmerMappingID),
        performOrderID: parseInt(supplierOrderDeails.performOrderID),
        cropForecastDetailID: parseInt(supplierData.cropForecastDetailID),
        operationEntityID: parseInt(supplierOrderDeails.operationEntityID),
        cropID: parseInt(supplierData.cropID),
        acceptedQuantity: parseFloat(supplierData.acceptedQuantity),
        dueDate: supplierOrderDeails.orderDate,
        productCode: supplierOrderDeails.productCode,
        breakdownDetails: breakdownDetails,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/Supplier/RemoveSupplier', null, values);
    return response;
}

async function EditSuppliers(supplierData, supplierOrderUpdateDeails, supplierOrderDeails, found, breakdownDetails) {
    var values = {
        performOrderFarmerMappingID: parseInt(supplierOrderUpdateDeails.performOrderFarmerMappingID),
        performOrderID: parseInt(supplierData.performOrderID),
        cropForecastDetailID: parseInt(supplierOrderDeails.cropForecastDetailID),
        acceptedQuantity: parseFloat(supplierOrderDeails.quantity),
        remainingQuantity: ((parseFloat(supplierData.quantity) - parseFloat(supplierData.returnQuantity)) - ((parseFloat(supplierData.acceptedQuantity) - parseFloat(supplierOrderUpdateDeails.acceptedQuantity)) + parseFloat(supplierOrderDeails.quantity))),
        acceptedOldQuantity: parseFloat(parseFloat(supplierOrderUpdateDeails.acceptedQuantity) - parseFloat(supplierOrderDeails.quantity)),
        existsQuantity: parseFloat(found.quantity) + parseFloat(supplierOrderDeails.availbaleQty),
        existsAcceptedQuantity: ((parseFloat(supplierData.acceptedQuantity) - parseFloat(supplierOrderUpdateDeails.acceptedQuantity)) + parseFloat(supplierOrderDeails.quantity)),
        dueDate: supplierData.orderDate,
        productCode: supplierData.productCode,
        operationEntityID: parseInt(supplierData.operationEntityID),
        cropID: parseInt(supplierData.cropID),
        breakdownDetails: breakdownDetails,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/Supplier/EditSupplier', null, values);
    return response;
}

async function ReturnOrder(returnOrderData, supplierOrderUpdateDeails) {
    var values = {
        performOrderID: parseInt(supplierOrderUpdateDeails.performOrderID),
        operationEntityID: parseInt(supplierOrderUpdateDeails.operationEntityID),
        operationEntityCode: supplierOrderUpdateDeails.operationEntityCode,
        factoryName: supplierOrderUpdateDeails.factoryName,
        cropID: parseInt(supplierOrderUpdateDeails.cropID),
        productCode: supplierOrderUpdateDeails.productCode,
        productName: supplierOrderUpdateDeails.productName,
        returnQuantity: parseFloat(supplierOrderUpdateDeails.reaminingQuantity),
        orderDate: supplierOrderUpdateDeails.orderDate,
        realizedPrice: parseFloat(supplierOrderUpdateDeails.realizedPrice),
        reason: returnOrderData.reason,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/Supplier/ReturnOrder', null, values);
    return response;
}

async function ApproveReadyToWeighment(data) {
    var values = {
        performOrderFarmerMappingID: parseInt(data.performOrderFarmerMappingID),
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/Supplier/ApproveReadyToWeighment', null, values);
    return response;
}

async function GetVCCOrderBreakdownDetailsByPerformOrderID(performOrderID) {
    const response = await CommonGet('/api/Supplier/GetVCCOrderBreakdownDetailsByPerformOrderID', 'performOrderID=' + parseInt(performOrderID));
    return response.data;
}